import { ElementRef, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { CustomDateComponent } from '../../reports/customdate/custom-date.component';
import { MatDialog } from '@angular/material';
import { FeederReportsComponent } from '../feeder-reports/feeder-reports.component';
import { FeederpopupComponent } from '../feederpopup/feederpopup.component';
import { ManagerComponent } from '../manager/manager.component';
var FeederdashboardComponent = /** @class */ (function () {
    function FeederdashboardComponent(feederService, matDialog, ngxLoader, router) {
        this.feederService = feederService;
        this.matDialog = matDialog;
        this.ngxLoader = ngxLoader;
        this.router = router;
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.roleid = this.currentUserData.roleid;
        this.userid = this.currentUserData.userid;
        this.feederOptions = [];
        this.displayedOptions = [];
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.timeFilter = 'Today';
        this.paramAlertStatus = { "overload": "0", "underload": "0", "criticalLoad": "0", "lugtemp": "0", "highVolt": "0", "lowVolt": "0", "IUnbalance": "0", "VUnbalance": "0" };
        this.customDate = { startDate: '', endDate: '' };
        this.isFeederData = false;
        this.paramList = ['Current', 'Voltage', 'PF', 'Load', 'Current THD', 'Voltage THD', 'Humidity & Temp', 'LUG Temp'];
        this.selectedParam = this.paramList[0];
    }
    FeederdashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.ngxLoader.startLoader("feeder");
        this.feederService.getFeeders({ "userid": this.userid, "roleid": this.roleid }).subscribe(function (response) {
            if (response.data.length > 0) {
                _this.feederOptions = [];
                _this.displayedOptions = [];
                //console.log("Response >>>>>", response.data);
                response.data.forEach(function (element) {
                    _this.feederOptions.push(element.transformerid);
                    _this.displayedOptions.push(element.id + '[' + element.sitename + ']');
                });
                _this.feederOptions.sort();
                _this.displayedOptions.sort();
                //this.selectedFeeder = this.feederOptions[0];
                _this.displayedFeeder = _this.displayedOptions[0];
                console.log("feederOptions", _this.feederOptions);
                console.log('displayedOptions', _this.displayedOptions);
                _this.getFeederTileData(_this.feederOptions);
                _this.getFeeerAlertParamStatus(_this.feederOptions);
                _this.getFeederData(_this.displayedFeeder);
            }
        });
    };
    FeederdashboardComponent.prototype.openManagerSettings = function () {
        var dialogRef;
        dialogRef = this.matDialog.open(ManagerComponent, {
            height: '70%',
            width: '40%',
        });
    };
    FeederdashboardComponent.prototype.getFeederTileData = function (feederList) {
        var _this = this;
        this.allTileData = null;
        this.feederService.getFeederTileData({ "feederList": feederList }).subscribe(function (response) {
            //console.log("RESPONSE FOR FEEDER", response)
            if (response.code == '1') {
                _this.allTileData = response.data;
                console.log("tile data >>>>>>>>>", _this.allTileData);
            }
            _this.ngxLoader.stopLoader("feeder");
        });
    };
    FeederdashboardComponent.prototype.getFeeerAlertParamStatus = function (feederList) {
        var _this = this;
        this.paramAlertStatus = { "overload": "0", "underload": "0", "criticalLoad": "0", "lugtemp": "0", "highVolt": "0", "lowVolt": "0", "IUnbalance": "0", "VUnbalance": "0" };
        this.feederService.getFeederAlertParamStatus({ "feederList": feederList }).subscribe(function (response) {
            //console.log("Response for FEEDER", response);
            if (response.code == '1') {
                console.log("ALERT STATUS >>>>", response.data);
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].paramName.toLowerCase() == 'overload') {
                        _this.paramAlertStatus.overload = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "underload") {
                        _this.paramAlertStatus.underload = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "criticalload") {
                        _this.paramAlertStatus.criticalLoad = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "lugtemp") {
                        _this.paramAlertStatus.lugtemp = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "highvoltage") {
                        _this.paramAlertStatus.highVolt = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "lowvoltage") {
                        _this.paramAlertStatus.lowVolt = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "iunbalance") {
                        _this.paramAlertStatus.IUnbalance = response.data[i].p_count;
                    }
                    else if (response.data[i].paramName.toLowerCase() == "vunbalance") {
                        _this.paramAlertStatus.VUnbalance = response.data[i].p_count;
                    }
                }
                console.log("INDIVIDUAL STATUS>>>>>", _this.paramAlertStatus);
            }
        });
    };
    FeederdashboardComponent.prototype.getFeederData = function (feederid) {
        var _this = this;
        this.ngxLoader.startLoader("feederChanger");
        feederid = _.cloneDeep(feederid).split('[')[0];
        this.date = [];
        this.feederData = [];
        console.log("DATE SELECETED", this.timeFilter);
        if (this.timeFilter.toLowerCase() == 'custom') {
            //CODE FOR CUSTOM API
            this.feederService.getFeederData({ "feederid": feederid, "duration": { "type": this.timeFilter, "startDate": this.customDate.startDate, "endDate": this.customDate.endDate } }).subscribe(function (response) {
                console.log("FEEDER DATA >>>>>", response);
                if (response.data.length > 0) {
                    _this.graphIndividual();
                    _this.isFeederData = true;
                    response.data.forEach(function (element) {
                        _this.date.push(element.DATE);
                        _this.feederData.push(JSON.parse(element.readings));
                    });
                    console.log("DATE AND READINGS >>>>", _this.date, _this.feederData);
                    //this.selectedParam = this.paramList[0];
                    //this.updateCurrent();
                    _this.parameterSelection(_this.selectedParam);
                    _this.ngxLoader.stopLoader("feederChanger");
                }
                else {
                    _this.ngxLoader.stopLoader("feederChanger");
                    _this.isFeederData = false;
                    _this.date = null;
                    _this.feederData = null;
                    _this.chart_i.destroy();
                    console.log("THERE IS NO DATA FOR THIS SWITCH FOR SELECTED TIME");
                }
            });
        }
        else {
            //CODE FOR REST OF DURATIONS
            this.feederService.getFeederData({ "feederid": feederid, "duration": { "type": this.timeFilter } }).subscribe(function (response) {
                console.log("FEEDER DATA >>>>>", response);
                if (response.data.length > 0) {
                    _this.graphIndividual();
                    _this.isFeederData = true;
                    response.data.forEach(function (element) {
                        _this.date.push(element.DATE);
                        _this.feederData.push(JSON.parse(element.readings));
                    });
                    console.log("DATE AND READINGS >>>>", _this.date, _this.feederData);
                    //this.selectedParam = this.paramList[0];
                    //this.updateCurrent();
                    _this.parameterSelection(_this.selectedParam);
                }
                else {
                    _this.ngxLoader.stopLoader("feederChanger");
                    _this.isFeederData = false;
                    _this.date = null;
                    _this.feederData = null;
                    _this.chart_i.destroy();
                    console.log("THERE IS NO DATA FOR THIS SWITCH FOR SELECTED TIME");
                }
                _this.ngxLoader.stopLoader("feederChanger");
            });
        }
    };
    FeederdashboardComponent.prototype.dateSelection = function () {
        var _this = this;
        console.log("TIME Filler ", this.timeFilter);
        if (this.timeFilter.toLowerCase() == 'custom') {
            //const dialogConfig = new MatDialogConfig();
            var dialogRef = this.matDialog.open(CustomDateComponent, {
                autoFocus: false,
                height: '350px', width: '450px'
            });
            dialogRef.afterClosed().subscribe(function (value) {
                console.log("VALUE", value);
                _this.customDate.startDate = value.startDate;
                _this.customDate.endDate = value.endDate;
                _this.getFeederData(_this.displayedFeeder);
            });
        }
        else {
            this.getFeederData(this.displayedFeeder);
        }
    };
    FeederdashboardComponent.prototype.parameterSelection = function (param) {
        this.ngxLoader.startLoader("feederChanger");
        this.selectedParam = param;
        if (this.selectedParam.toLowerCase() == 'current') {
            console.log('IN CURRENT');
            this.updateCurrent();
        }
        else if (this.selectedParam.toLowerCase() == 'voltage') {
            console.log('IN VOLTAGE');
            this.updateVoltage();
        }
        else if (this.selectedParam.toLowerCase() == 'pf') {
            console.log('IN PF');
            this.updatePF();
        }
        else if (this.selectedParam.toLowerCase() == 'load') {
            console.log('IN LOAD');
            this.updateLoad();
        }
        else if (this.selectedParam.toLowerCase() == 'current thd') {
            console.log('IN CURRENT THD');
            this.updateCurrentTHD();
        }
        else if (this.selectedParam.toLowerCase() == 'voltage thd') {
            console.log('IN VOLTAGE THD');
            this.updateVoltageTHD();
        }
        else if (this.selectedParam.toLowerCase() == 'humidity & temp') {
            console.log('IN HUMIDITY & TEMP');
            this.updateHumidity();
        }
        else if (this.selectedParam.toLowerCase() == 'lug temp') {
            console.log('IN lug TEMP');
            this.updateLUG();
        }
        this.ngxLoader.stopLoader("feederChanger");
    };
    FeederdashboardComponent.prototype.graphIndividual = function () {
        var options = {
            series: [{
                    name: "Value",
                    data: [0]
                }],
            chart: {
                type: 'line',
                height: "100%",
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 4
            },
            /*title: {
              text: 'Individual Meter Graph Data',
              style: {
                    color: "black",
                    fontWeight: 'bold'
                  },
              align: 'left',
             
            },*/
            xaxis: {
                type: 'DateTime',
                tickAmount: 3,
                tickPlacement: 'between',
                intervalType: 'Hours',
                labels: {
                    show: true,
                    style: {
                        colors: 'black',
                        fontWeight: 'bold'
                    },
                    rotate: 0,
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: 'black'
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left'
            }
        };
        this.chart_i = new ApexCharts(this.individual_graph.nativeElement, options);
        this.chart_i.render();
    };
    FeederdashboardComponent.prototype.updateCurrent = function () {
        if (this.feederData) {
            var I1 = this.feederData.map(function (result) { return (result.L1); });
            var I2 = this.feederData.map(function (result) { return (result.L2); });
            var I3 = this.feederData.map(function (result) { return (result.L3); });
            this.chart_i.updateOptions({
                series: [{
                        name: 'L1',
                        data: I1,
                        type: 'line',
                        color: '#FF0000'
                    },
                    {
                        name: 'L2',
                        data: I2,
                        type: 'line',
                        color: '#0000FF'
                    },
                    {
                        name: 'L3',
                        data: I3,
                        type: 'line',
                        color: '#FFFF00'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'Current',
                    align: 'center',
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updateVoltage = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var V1 = this.feederData.map(function (result) { return (result.R_Ph_N); });
            var V2 = this.feederData.map(function (result) { return (result.Y_Ph_N); });
            var V3 = this.feederData.map(function (result) { return (result.B_Ph_N); });
            var avgVolt = this.feederData.map(function (result) { return (result.Average_Voltage); });
            console.log("VOLTAGE 3", V1, V2, V3);
            this.chart_i.updateOptions({
                series: [{
                        name: 'R_Ph_N',
                        data: V1,
                        type: 'line',
                        color: '#FF0000'
                    },
                    {
                        name: 'Y_Ph_N',
                        data: V2,
                        type: 'line',
                        color: '#0000FF'
                    },
                    {
                        name: 'B_Ph_N',
                        data: V3,
                        type: 'line',
                        color: '#FFFF00'
                    },
                    {
                        name: 'Average Voltage',
                        data: avgVolt,
                        type: 'line',
                        color: '#008000'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'Voltage',
                    align: 'center',
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updatePF = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var r_pf = this.feederData.map(function (result) { return (result.R_Power_Factor); });
            var y_pf = this.feederData.map(function (result) { return (result.Y_Power_Factor); });
            var b_pf = this.feederData.map(function (result) { return (result.B_Power_Factor); });
            var avg_pf = this.feederData.map(function (result) { return (result.Avg_Power_Factor); });
            this.chart_i.updateOptions({
                series: [{
                        name: 'R_Power_Factor',
                        data: r_pf,
                        type: 'line',
                        color: '#FF0000'
                    },
                    {
                        name: 'Y_Power_Factor',
                        data: b_pf,
                        type: 'line',
                        color: '#0000FF'
                    },
                    {
                        name: 'B_Power_Factor',
                        data: y_pf,
                        type: 'line',
                        color: '#FFFF00'
                    },
                    {
                        name: 'Avg_Power_Factor',
                        data: avg_pf,
                        type: 'line',
                        color: '#008000'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'PF',
                    align: 'center',
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updateLoad = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var load = this.feederData.map(function (result) { return (result.load); });
            this.chart_i.updateOptions({
                series: [{
                        name: 'Load',
                        data: load,
                        type: 'line',
                        color: '#008000'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'Load (%)',
                    align: 'center'
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updateCurrentTHD = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var ir_Thd = this.feederData.map(function (result) { return (result.IR_THD); });
            var ib_Thd = this.feederData.map(function (result) { return (result.IY_THD); });
            var iy_Thd = this.feederData.map(function (result) { return (result.IB_THD); });
            this.chart_i.updateOptions({
                series: [{
                        name: 'R Phase THD',
                        data: ir_Thd,
                        type: 'line',
                        color: '#FF0000'
                    },
                    {
                        name: 'Y Phase THD',
                        data: iy_Thd,
                        type: 'line',
                        color: '#FFFF00'
                    },
                    {
                        name: 'B Phase THD',
                        data: ib_Thd,
                        type: 'line',
                        color: '#0000FF'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'Current THD',
                    align: 'center'
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updateVoltageTHD = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var vr_Thd = this.feederData.map(function (result) { return (result.VR_THD); });
            var vb_Thd = this.feederData.map(function (result) { return (result.VY_THD); });
            var vy_Thd = this.feederData.map(function (result) { return (result.VB_THD); });
            this.chart_i.updateOptions({
                series: [{
                        name: 'R Phase THD',
                        data: vr_Thd,
                        type: 'line',
                        color: '#FF0000'
                    },
                    {
                        name: 'B Phase THD',
                        data: vy_Thd,
                        type: 'line',
                        color: '#FFFF00'
                    },
                    {
                        name: 'B Phase THD',
                        data: vb_Thd,
                        type: 'line',
                        color: '#0000FF'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'Voltage THD',
                    align: 'center'
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updateHumidity = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var humidity = this.feederData.map(function (result) { return (result.Humidity); });
            var temp = this.feederData.map(function (result) { return (result.Ambient_Temperature); });
            this.chart_i.updateOptions({
                series: [{
                        name: 'Humitidy',
                        type: 'line',
                        data: humidity,
                        color: '#FFA500'
                    },
                    {
                        name: 'Ambient_Temperature',
                        type: 'line',
                        data: temp,
                        color: '#00FF00'
                    }],
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'Humidity and Temperature',
                    align: 'center'
                }
            });
        }
    };
    FeederdashboardComponent.prototype.updateLUG = function () {
        if (Array.isArray(this.feederData) && this.feederData.length > 0) {
            var LTSeries = [];
            var _loop_1 = function (i) {
                LTSeries.push({
                    name: "LUG Temp " + i,
                    data: this_1.feederData.map(function (result) { return result["LT_" + i]; }),
                    type: 'line',
                    // Assign different colors if needed, here are some example colors:
                    color: ['#FF0000', '#FFFF00', '#0000FF', '#00FF00', '#FF00FF', '#00FFFF', '#FFA500', '#800080', '#008000', '#FFC0CB', '#800000', '#808000'][i - 1]
                });
            };
            var this_1 = this;
            for (var i = 1; i <= 12; i++) {
                _loop_1(i);
            }
            this.chart_i.updateOptions({
                series: LTSeries,
                xaxis: {
                    categories: this.date
                },
                title: {
                    text: 'LUG TEMP',
                    align: 'center'
                },
                stroke: {
                    width: 2
                }
            });
        }
    };
    FeederdashboardComponent.prototype.openAlertReport = function () {
        var feederID = _.cloneDeep(this.displayedFeeder).split('[')[0];
        console.log("Displayed Feeder", feederID);
        var dialogRef = this.matDialog.open(FeederReportsComponent, {
            height: '70%',
            width: '75%',
            data: { "selectedFeeder": feederID, "feederOptions": this.feederOptions, 'displayedOptions': this.displayedOptions, 'displayedFeeder': this.displayedFeeder, 'selectedDuration': this.timeFilter, 'timeOptions': this.timeOptions, 'startDate': this.customDate.startDate, 'endDate': this.customDate.endDate, 'type': 'alert' }
        });
    };
    FeederdashboardComponent.prototype.openGatewayReport = function () {
        var feederID = _.cloneDeep(this.displayedFeeder).split('[')[0];
        console.log("Displayed Feeder", feederID);
        var dialogRef = this.matDialog.open(FeederReportsComponent, {
            height: '90%',
            width: '95%',
            data: { "selectedFeeder": feederID, "feederOptions": this.feederOptions, "displayedOptions": this.displayedOptions, "displayedFeeder": this.displayedFeeder, "selectedDuration": this.timeFilter, "timeOptions": this.timeOptions, "startDate": this.customDate.startDate, "endDate": this.customDate.endDate, "type": "gateway" }
        });
    };
    FeederdashboardComponent.prototype.popupTable = function (state, selected) {
        var dialogRef;
        dialogRef = this.matDialog.open(FeederpopupComponent, {
            height: '55%',
            width: '55%',
            data: { 'state': state, 'selected': selected, 'feederOptions': this.feederOptions }
        });
    };
    return FeederdashboardComponent;
}());
export { FeederdashboardComponent };
